<template>
  <div class="container-breadcrumb">
    <!--面包屑部分-->
    <a-breadcrumb>
      <span class="container-breadcrumb-icon">当前位置:</span>
      <template #separator><span class="separator" /></template>
      <a-breadcrumb-item v-for="item in list" class="ant-breadcrumb-item">{{ item }}</a-breadcrumb-item>
    </a-breadcrumb>
    <!--右侧的插槽，用于放置按钮类-->
    <slot name="right"></slot>
  </div>
</template>

<script>
import { getRouteInfo } from '../config';
export default {
  name: 'LayoutBreadcrumb',
  data() {
    return {
      // 循环使用的面包屑
      list: [],
    };
  },
  watch: {
    $route: {
      handler(route) {
        // 根据当前路由计算对应的面包屑信息
        let menu = getRouteInfo(route.path);
        this.list = menu.breadcrumb;
      },
      immediate: true,
    },
  },
};
</script>

<style lang="scss" scoped>
// 面包屑当前位置的颜色
$color-local: rgba(21, 40, 77, 0.45);
// 面包屑上级菜单的颜色
$color-submenu: rgba(21, 40, 77, 0.65);
// 面包屑当前位置的颜色
$color-menu: rgba(0, 0, 0, 0.65);

.container-breadcrumb {
  display: flex;
  align-items: center;
  justify-content: space-between;
  /deep/ .ant-breadcrumb {
    padding: 0 16px;
    line-height: unset;
    // 前侧的定位的按钮图标
    .container-breadcrumb-icon {
      margin: {
        right: 5px;
      }
      color: $color-local;
      &::before {
        content: '';
        display: inline-block;
        width: 12px;
        height: 12px;
        background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAMAAADXqc3KAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAA2UExURUdwTCRx0y1z2CRx0yd11yV01CR21yR01y1z3Sdz1iRy0yRx0yd01yVy0yRy0yZy1SVy0yRx0ijUBkoAAAARdFJOUwDyC9cZUxEmBiDB6Th2naqLWCo+tQAAAMJJREFUKM9dkVEChCAIRDURJWHL+192Fcy0+aJ5DqA59yhFkZjcRzmGqgpx82nYiuj1U6mLyuyHoW4KOMCvfvQbjcY5YZaRtWai9ZlUp36IAq09G2CvpxQUCxABEVmk6N1sHgE2AdkmuQNLAOYmBEt0cNiMlDWebMbRwV1n7bJtdSvg5/kAnqdkBXB9b36BAS67X1hBRop+9X0k1HUR0kp8TIC2ItJCmm+BBg54SffhyOOH4yTqj8Akbbey+4OwCL/+HzlEFHwdrqu7AAAAAElFTkSuQmCC);
        background-size: 100% 100%;
        margin-right: 5px;
      }
    }

    // 分隔符
    .ant-breadcrumb-separator {
      margin: 0;
      .separator {
        &::after {
          content: '';
          display: inline-block;
          width: 14px;
          height: 14px;
          background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYBAMAAAASWSDLAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAhUExURUdwTBYpTBcpTBksUBcoTBgrTRgpTTBAYBorTh4tUhcpS+HdsKIAAAALdFJOUwBwXhRnO1EFHwss8WdEewAAAExJREFUGNNjYMAHmAKQOKyiyFKJC5A4ZRJIHHbFBiTeJGEkDqeLARLPxBOJwyxUgMRrTMDBQVGGbACK0ciWojgHxaHIXkDxHIq3sQMA43ALUfhBSuMAAAAASUVORK5CYII=);
          background-size: 100% 100%;
          margin-left: 5px;
          vertical-align: middle;
        }
      }
    }

    // 面包屑分项
    .ant-breadcrumb-item {
      margin-right: 10px;
      color: $color-submenu;
      &:last-child {
        color: $color-menu;
      }
    }
  }
}
</style>
